import React, {useEffect, useState} from "react";
import {toDateStringIgnoringTimezone, toDateTimeString} from "../../utils/TimeUtil";


import {IndexTemplate, Loading} from "../../utils/InlineComponents";
import {AppContext} from "../../HomePage";
import {ScraperService} from "../../service/ScraperService";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {exportFile, getKeyValue, getLinkFromUrl, getProductDetailLink} from "../../utils/Utils";
import {MultiSelect} from "primereact/multiselect";
import {SelectButton} from "primereact/selectbutton";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import {AiJobService} from "../../service/AiJobService";
import {RequestProbeService} from "../../service/RequestProbeService";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";

const OverviewRequest = (props) =>{

    const {t, toast, setError} = React.useContext(AppContext);

    const [date, setDate] = useState("");

    const [loading, setLoading] = useState(false);
    const [failedRequestsDigest, setFailedRequestsDigest] = useState([]);
    const [filteredFailedRequestsDigest, setFilteredFailedRequestsDigest] = useState([]);
    const [filteredFailedRequestsBasedHostname, setFilteredFailedRequestsBasedHostname] = useState([]);
    const [jobsRunTime, setJobsRunTime] = useState([]);
    const [filteredJobsRunTime, setFilteredJobsRunTime] = useState([]);
    const [totalRealFailure, setTotalRealFailure] = useState(0);
    const [totalConnectionFailure, setTotalConnectionFailure] = useState(0);
    const [totalHttp5xx, setTotalHttp5xx] = useState(0);
    const [totalHttp4xx, setTotalHttp4xx] = useState(0);

    const [filteredUserEmails, setFilteredUserEmails] = useState([]);
    const [userOptions, setUserOptions] = useState([]);

    const scraperService = new ScraperService();
    const aiJobService = new AiJobService();
    const requestProbeService = new RequestProbeService();

    // Open a dialog letting the user pick one of the failing product URLs, then
    // create a product_url request probe for it (diagnosable from Request Probe).
    const openProbeDialog = () => {
        const products = getFailedProductLinks();
        const first = products.find(p => p.competitor_url || p.product_url);
        setProbeUrl(first ? (first.competitor_url || first.product_url) : null);
        setShowProbeDialog(true);
    };

    const probeUrlOptions = () => getFailedProductLinks()
        .map((p, index) => ({
            label: "Product " + (index + 1) + " — " + (p.competitor_url || p.product_url || "-"),
            value: p.competitor_url || p.product_url,
            product_id: p.product_id,
        }))
        .filter(option => option.value);

    const createProductUrlProbe = () => {
        if (!probeUrl)
            return;
        const option = probeUrlOptions().find(o => o.value === probeUrl);
        setProbeLoading(true);
        requestProbeService.createProbe(probeUrl, 'product_url', null, {
            product_id: option ? option.product_id : undefined,
        }).then(() => {
            setProbeLoading(false);
            setShowProbeDialog(false);
            toast.current.show({severity: 'success', summary: t('request_probe.create_new'), detail: t('message_detail.successful')});
        }).catch(error => {
            setProbeLoading(false);
            setError(error);
            setError(null);
        });
    };

    const [selectedFailureDetail, setSelectedFailureDetail] = useState(null);
    const [selectedFailureDetails, setSelectedFailureDetails] = useState([]);
    const [showFailureDetailModal, setShowFailureDetailModal] = useState(false);
    const [showProbeDialog, setShowProbeDialog] = useState(false);
    const [probeUrl, setProbeUrl] = useState(null);
    const [probeLoading, setProbeLoading] = useState(false);
    const [copyingFailureResponseHash, setCopyingFailureResponseHash] = useState(null);
    const [showAiJobCreateForm, setShowAiJobCreateForm] = useState(false);
    const [aiProvider, setAiProvider] = useState("gemini");
    const [aiModelName, setAiModelName] = useState(null);
    const [aiBaseBranch, setAiBaseBranch] = useState("master");
    const [aiOperations, setAiOperations] = useState([]);
    const [aiOperationsLoading, setAiOperationsLoading] = useState(false);
    const [aiJobs, setAiJobs] = useState([]);
    const [aiJobsLoading, setAiJobsLoading] = useState(false);
    const [aiJobCreateLoading, setAiJobCreateLoading] = useState(false);
    const [aiJobError, setAiJobError] = useState(null);
    const [selectedAiJobDetails, setSelectedAiJobDetails] = useState(null);
    const [selectedApproveJob, setSelectedApproveJob] = useState(null);
    const [approvingAiJobId, setApprovingAiJobId] = useState(null);
    const [manualPromptData, setManualPromptData] = useState(null);
    const [manualPromptLoading, setManualPromptLoading] = useState(false);
    const [responseDownloadLoading, setResponseDownloadLoading] = useState(false);
    const [selectedCorrectionJob, setSelectedCorrectionJob] = useState(null);
    const [correctionReviewNote, setCorrectionReviewNote] = useState("");
    const [correctionLoading, setCorrectionLoading] = useState(false);
    const [correctionError, setCorrectionError] = useState(null);
    const [aiJobLogsLoading, setAiJobLogsLoading] = useState(false);
    const [expandedAiJobLogRows, setExpandedAiJobLogRows] = useState(null);
    const [selectedListType, setSelectedListType] = useState('failed_requests_based_hostname');
    const listTypes = [
        {label: t('scraping_request.failed_requests_based_hostname'), value: 'failed_requests_based_hostname'},
        {label: t('scraping_request.failed_requests_overview'), value: 'failed_requests_overview'},
        {label: t('scraping_request.jobs_runtime'), value: 'jobs_runtime'}
    ];

    useEffect ( ()=>{
        if (date) {
            if (selectedListType === "failed_requests_overview") {
                listFailedRequestsDigest(date);
            }
            else if (selectedListType === "failed_requests_based_hostname") {
                listFailedRequestsBasedHostname(date);
            }
            else if(selectedListType === "jobs_runtime") {
                listJobsRunTime(date);
            }

        }
    },[date, selectedListType]);

    const listFailedRequestsDigest = (selectedDate) => {
        setLoading(true);
        scraperService.listFailedRequestsDigest(toDateStringIgnoringTimezone(selectedDate), toDateStringIgnoringTimezone(selectedDate)).then(data => {
            setFailedRequestsDigest(data);
            setFilteredFailedRequestsDigest(data);
            let userOptions = data.map(item => {return {"label":item.user_email, "value": item.user_email}});
            userOptions = [...new Map(userOptions.map(item => [item['value'], item])).values()];
            userOptions = userOptions.sort((a, b) => (a ? a.label : "").localeCompare((b ? b.label : ""), undefined, {sensitivity: 'base'}));
            setUserOptions(userOptions)
            setLoading(false);
        }).catch(error =>{
            setError(error);
            setError(null);
            setLoading(false);
        });
    };

    const filterItems = (e) => {
        const filteredUserEmails = getKeyValue(e).value
        setFilteredUserEmails(filteredUserEmails)
        let filteredFailedRequests = failedRequestsDigest.filter(item => filteredUserEmails.includes(item.user_email))
        let filteredJobsRunTime = jobsRunTime.filter(item => filteredUserEmails.includes(item.user_email))
        setFilteredFailedRequestsDigest(filteredFailedRequests)
        setFilteredJobsRunTime(filteredJobsRunTime)
    }

    const listFailedRequestsBasedHostname = (selectedDate) => {
        setLoading(true);
        scraperService.listFailedRequestsBasedHostname(toDateStringIgnoringTimezone(selectedDate), toDateStringIgnoringTimezone(selectedDate)).then(data => {
            setFilteredFailedRequestsBasedHostname(data);
            setTotalRealFailure(data.map(item => item.total_real_failure_count).reduce((a, b) => a + b, 0))
            setTotalConnectionFailure(data.map(item => item.total_connection_failure).reduce((a, b) => a + b, 0))
            setTotalHttp5xx(data.map(item => item.total_http_5xx).reduce((a, b) => a + b, 0))
            setTotalHttp4xx(data.map(item => item.total_http_4xx).reduce((a, b) => a + b, 0))
            setLoading(false);
        }).catch(error =>{
            setError(error);
            setError(null);
            setLoading(false);
        });
    };

    const listJobsRunTime = (selectedDate) => {
        setLoading(true);
        scraperService.listJobsRunTime(toDateStringIgnoringTimezone(selectedDate), toDateStringIgnoringTimezone(selectedDate)).then(data => {
            setJobsRunTime(data);
            setFilteredJobsRunTime(data);
            setLoading(false);
        }).catch(error =>{
            setError(error);
            setError(null);
            setLoading(false);
        });
    };

    const digestTemplate = (data) => {
        return (
            <React.Fragment>
                <button className="p-link" onClick={() => {window.open('#/scraping_job?scraping_request_id=' + data.id, '_blank');}}>
                    <span style={{textAlign: 'center', marginRight:"5px", width: "50px"}} className={"p-tag p-tag-info"}>{data.total_failure_count}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-warning"}>{data.user_email}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-success"}>{data.campaign_name}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-info"}>{data.type}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-danger"}>{data.total_real_failure_count}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-warning"}>{data.total_http_5xx}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-info"}>{data.total_http_4xx}</span>
                    <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-success"}>{data.total_connection_failure}</span>
                </button>
            </React.Fragment>
        );
    }

    const jobsRunTimeTemplate = (data) => {
        return (
            <React.Fragment>
                <span style={{textAlign: 'center', marginRight:"5px", width: "100px"}} className={"p-tag p-tag-danger"}>{data.duration}</span>
                <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-warning"}>{data.user_email}</span>
                <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-success"}>{data.campaign_name}</span>
                <span style={{textAlign: 'center', marginRight:"5px"}} className={"p-tag p-tag-info"}>{data.divided_job_units}</span>
            </React.Fragment>
        );
    }

    const previousDate = () => {
        if (date)
            setDate(toDateStringIgnoringTimezone((new Date(date)).setDate((new Date(date)).getDate()-1)));
    }
    const nextDate = () => {
        if (date)
            setDate(toDateStringIgnoringTimezone((new Date(date)).setDate((new Date(date)).getDate()+1)));
    }
    const selectDate = (e) => {
        setDate(toDateStringIgnoringTimezone(e.value));
    }

    const getFailureDetail = (rowData) => {
        return rowData.failure_details && rowData.failure_details.length > 0 ? rowData.failure_details[0] : rowData;
    };

    const getFailureDetails = (rowData) => {
        return rowData.failure_details && rowData.failure_details.length > 0 ? rowData.failure_details : [rowData];
    };

    const resetAiJobPanel = () => {
        setShowAiJobCreateForm(false);
        setAiProvider("gemini");
        setAiModelName(null);
        setAiBaseBranch("master");
        setAiOperations([]);
        setAiOperationsLoading(false);
        setAiJobs([]);
        setAiJobError(null);
        setSelectedAiJobDetails(null);
        setSelectedApproveJob(null);
        setManualPromptData(null);
        setSelectedCorrectionJob(null);
        setCorrectionReviewNote("");
        setCorrectionError(null);
        setAiJobLogsLoading(false);
        setExpandedAiJobLogRows(null);
    };

    const sortAiJobs = (jobs) => {
        return [...(jobs || [])].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
    };

    const sortAiJobLogs = (logs) => {
        return [...(logs || [])].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
    };

    const mergeAiJob = (currentJob, updatedJob) => {
        const normalizedUpdatedJob = updatedJob && updatedJob.logs ? {...updatedJob, logs: sortAiJobLogs(updatedJob.logs)} : updatedJob;
        return currentJob ? {...currentJob, ...normalizedUpdatedJob} : normalizedUpdatedJob;
    };

    const updateAiJobInList = (updatedJob) => {
        setAiJobs(currentJobs => {
            const existingJob = currentJobs.find(job => job.id === updatedJob.id);
            return sortAiJobs([mergeAiJob(existingJob, updatedJob), ...currentJobs.filter(job => job.id !== updatedJob.id)]);
        });
    };

    const loadAiJobs = (exception_hash) => {
        if (!exception_hash) {
            setAiJobs([]);
            setAiJobError(t('ai_job.exception_hash_missing'));
            return;
        }

        setAiJobsLoading(true);
        setAiJobError(null);
        aiJobService.getJobsByExceptionHash(exception_hash).then(data => {
            setAiJobs(sortAiJobs(data));
            setAiJobsLoading(false);
        }).catch(error => {
            setAiJobsLoading(false);
            if (error && error.response && error.response.status === 400) {
                setAiJobError(t('ai_job.exception_hash_missing'));
            } else if (error && error.response && error.response.status === 401) {
                setError(error);
                setError(null);
            } else {
                setAiJobError(t('ai_job.request_failed'));
            }
        });
    };

    const actionTemplate = (rowData) => {
        return <React.Fragment>
            <div className="p-grid p-align-center">
                <Button label="Exception Detail"
                        className="p-button-outlined p-button-danger preventSelect"
                        onClick={() => {
                            const failureDetail = getFailureDetail(rowData);
                            setSelectedFailureDetail(failureDetail);
                            setSelectedFailureDetails(getFailureDetails(rowData));
                            resetAiJobPanel();
                            loadAiJobs(failureDetail.exception_hash);
                            loadAiOperations();
                            setShowFailureDetailModal(true);
                        }}/>
            </div>
        </React.Fragment>;
    }

    // Deduped list of failing products (with their competitor URLs) for this error.
    const getFailedProductLinks = () => {
        const productLinks = [];
        const productKeys = new Set();
        selectedFailureDetails.forEach(failureDetail => {
            const productKey = failureDetail.product_id + "|" + failureDetail.competitor_url;
            if (failureDetail.product_id && !productKeys.has(productKey)) {
                productKeys.add(productKey);
                productLinks.push(failureDetail);
            }
        });
        return productLinks.slice(0, 5);
    };

    const failedProductsTemplate = () => {
        return getFailedProductLinks().map((failureDetail, index) =>
            <span key={failureDetail.product_id + "|" + failureDetail.competitor_url}>
                {getProductDetailLink(failureDetail.product_id, "Product " + (index + 1), failureDetail.competitor_url, true)}
            </span>
        );
    };

    const failedRedirectUrlTemplate = (rowData) => {
        return getLinkFromUrl(rowData.redirect_url);
    };

    const exceptionValueTemplate = (value) => {
        if (value === null || value === undefined || value === "")
            return null;
        if (typeof value === "object")
            return <pre style={{margin: 0, whiteSpace: "pre-wrap"}}>{JSON.stringify(value, null, 2)}</pre>;
        return value.toString();
    };

    const hasExceptionDetailValue = (value) => {
        if (value === null || value === undefined || value === "")
            return false;
        if (typeof value === "object")
            return Object.values(value).some(hasExceptionDetailValue);
        return true;
    };

    const exceptionTemplate = (rowData) => {
        const exceptionDetail = rowData.exception_detail;
        const hasExceptionDetail = hasExceptionDetailValue(exceptionDetail);

        if (hasExceptionDetail && typeof exceptionDetail === "object") {
            return <div style={{maxWidth: "32em", whiteSpace: "normal", wordBreak: "break-word"}}>
                {Object.entries(exceptionDetail).map(([key, value]) =>
                    <div key={key} style={{marginBottom: ".5em"}}>
                        <b>{key}: </b>{exceptionValueTemplate(value)}
                    </div>
                )}
            </div>;
        }

        return <div style={{maxWidth: "32em", whiteSpace: "normal", wordBreak: "break-word"}}>
            {hasExceptionDetail ? exceptionValueTemplate(exceptionDetail) : exceptionValueTemplate(rowData.exception)}
        </div>;
    };

    const copyFailureResponse = (rowData) => {
        if (!rowData.exception_hash)
            return;

        setCopyingFailureResponseHash(rowData.exception_hash);
        scraperService.getFailureResponse(rowData.exception_hash).then(data => {
            navigator.clipboard.writeText(data && data.response_text ? data.response_text : "").then(() => {
                toast.current.show({severity: 'success', summary: t('actions.copied'), detail: t('message_detail.successful')});
                setCopyingFailureResponseHash(null);
            }).catch(error => {
                setError(error);
                setError(null);
                setCopyingFailureResponseHash(null);
            });
        }).catch(error => {
            setError(error);
            setError(null);
            setCopyingFailureResponseHash(null);
        });
    };

    const failureResponseTemplate = (rowData) => {
        if (!rowData.exception_hash)
            return null;

        const isCopying = copyingFailureResponseHash === rowData.exception_hash;

        return <Button label={t('actions.copy_response_body')}
                       icon={isCopying ? "pi pi-spin pi-spinner" : "pi pi-copy"}
                       className="p-button-outlined p-button-success preventSelect"
                       disabled={isCopying}
                       onClick={(e) => {
                           e.stopPropagation();
                           copyFailureResponse(rowData);
                       }}/>;
    };

    const getFailureResponseFilename = (exceptionHash, response) => {
        const contentDisposition = response && response.headers ? response.headers["content-disposition"] : null;
        const filenameMatch = contentDisposition ? contentDisposition.match(/filename="?([^"]+)"?/) : null;
        if (filenameMatch && filenameMatch[1])
            return filenameMatch[1];
        return "response_" + (exceptionHash || "").substring(0, 16) + ".txt";
    };

    const downloadFailureResponse = (exceptionHash, filename) => {
        if (!exceptionHash)
            return;

        setResponseDownloadLoading(true);
        scraperService.downloadFailureResponse(exceptionHash).then(response => {
            exportFile(response, filename || getFailureResponseFilename(exceptionHash, response));
            setResponseDownloadLoading(false);
        }).catch(error => {
            setResponseDownloadLoading(false);
            setError(error);
            setError(null);
        });
    };

    const buildManualPrompt = () => {
        if (!selectedFailureDetail || !selectedFailureDetail.exception_hash)
            return;

        setManualPromptLoading(true);
        aiJobService.buildFixSpiderPrompt(selectedFailureDetail.exception_hash).then(data => {
            setManualPromptData(data);
            setManualPromptLoading(false);
        }).catch(error => {
            setManualPromptLoading(false);
            setError(error);
            setError(null);
        });
    };

    const copyManualPrompt = () => {
        if (!manualPromptData || !manualPromptData.prompt)
            return;

        navigator.clipboard.writeText(manualPromptData.prompt).then(() => {
            toast.current.show({severity: 'success', summary: t('actions.copied'), detail: t('message_detail.successful')});
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const getAiJobErrorMessage = (error) => {
        const data = error && error.response && error.response.data ? error.response.data : null;
        return (data && data.error) ||
            (data && data.data && data.data.error_message) ||
            (data && data.message) ||
            t('ai_job.request_failed');
    };

    const getAiJobApprovalErrorMessage = (error) => {
        const data = error && error.response && error.response.data ? error.response.data : null;
        return (data && data.error) ||
            (data && data.data && data.data.error_message) ||
            (data && data.message);
    };

    const canApproveAiJob = (job) => {
        return job && job.status === "waiting_user_review" && job.pull_request_url;
    };

    const canRequestAiJobCorrection = (job) => {
        return job && (job.status === "waiting_user_review" || job.status === "correction_failed");
    };

    const openAiJobCorrectionDialog = (job) => {
        setSelectedCorrectionJob(job);
        setCorrectionReviewNote("");
        setCorrectionError(null);
    };

    const getFixSpiderOperation = (operations = aiOperations) => {
        return (operations || []).find(operation => operation.domain === "scraper" && operation.operation === "fix-spider");
    };

    const normalizeAiOperations = (data) => {
        if (Array.isArray(data))
            return data;
        if (data && data.providers)
            return [{domain: "scraper", operation: "fix-spider", repo: "pricescraper", providers: data.providers}];
        return [];
    };

    const getProviderModels = (providerName = aiProvider) => {
        const operation = getFixSpiderOperation();
        const provider = operation && operation.providers ? operation.providers.find(item => item.name === providerName) : null;
        return provider && provider.models ? provider.models : [];
    };

    const getSelectedProvider = (providerName = aiProvider) => {
        const operation = getFixSpiderOperation();
        return operation && operation.providers ? operation.providers.find(item => item.name === providerName) : null;
    };

    const selectProviderDefaults = (providerName, operations = aiOperations) => {
        const operation = getFixSpiderOperation(operations);
        const provider = operation && operation.providers ? operation.providers.find(item => item.name === providerName) : null;
        const models = provider && provider.models ? provider.models : [];
        const defaultModel = models.find(model => model.name === (provider ? provider.default_model : null)) || models[0];

        setAiProvider(providerName);
        setAiModelName(defaultModel ? defaultModel.name : null);
    };

    const loadAiOperations = () => {
        setAiOperationsLoading(true);
        aiJobService.getOperations().then(data => {
            const operations = normalizeAiOperations(data);
            const operation = getFixSpiderOperation(operations);
            const implementedProvider = operation && operation.providers
                ? operation.providers.find(provider => provider.is_implemented !== false && provider.models && provider.models.length > 0)
                : null;
            const preferredProvider = operation && operation.providers
                ? operation.providers.find(provider => provider.name === aiProvider && provider.is_implemented !== false && provider.models && provider.models.length > 0)
                : null;

            setAiOperations(operations);
            if (preferredProvider || implementedProvider) {
                selectProviderDefaults((preferredProvider || implementedProvider).name, operations);
            } else {
                setAiModelName(null);
            }
            setAiOperationsLoading(false);
        }).catch(error => {
            setAiOperationsLoading(false);
            setError(error);
            setError(null);
        });
    };

    const openAiJobCreateForm = () => {
        setShowAiJobCreateForm(true);
        if (aiOperations.length === 0)
            loadAiOperations();
    };

    const createAiJob = (provider = aiProvider, baseBranch = aiBaseBranch, modelName = aiModelName) => {
        if (!selectedFailureDetail || !selectedFailureDetail.exception_hash)
            return;

        setAiJobCreateLoading(true);
        setAiJobError(null);
        aiJobService.createFixSpiderJob(selectedFailureDetail.exception_hash, provider, baseBranch, modelName).then(data => {
            updateAiJobInList(data);
            setShowAiJobCreateForm(false);
            setAiJobCreateLoading(false);
            toast.current.show({severity: 'success', summary: t('ai_job.created'), detail: t('message_detail.successful')});
            loadAiJobs(selectedFailureDetail.exception_hash);
        }).catch(error => {
            setAiJobError(getAiJobErrorMessage(error));
            setAiJobCreateLoading(false);
        });
    };

    const refreshAiJob = (job) => {
        aiJobService.getJob(job.id).then(data => {
            updateAiJobInList(data);
            if (selectedAiJobDetails && selectedAiJobDetails.id === data.id) {
                setSelectedAiJobDetails(mergeAiJob(selectedAiJobDetails, data));
            }
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const openAiJobDetails = (job) => {
        setSelectedAiJobDetails(job);
        setExpandedAiJobLogRows(null);
        aiJobService.getJob(job.id).then(data => {
            updateAiJobInList(data);
            setSelectedAiJobDetails(mergeAiJob(job, data));
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const refreshAiJobLogs = (jobId) => {
        if (!jobId)
            return;

        setAiJobLogsLoading(true);
        aiJobService.getJobLogs(jobId).then(data => {
            const logs = sortAiJobLogs(data);
            updateAiJobInList({id: jobId, logs: logs});
            setSelectedAiJobDetails(currentJob => currentJob && currentJob.id === jobId ? {...currentJob, logs: logs} : currentJob);
            setExpandedAiJobLogRows(null);
            setAiJobLogsLoading(false);
        }).catch(error => {
            setAiJobLogsLoading(false);
            setError(error);
            setError(null);
        });
    };

    const approveAiJob = () => {
        if (!selectedApproveJob)
            return;

        setApprovingAiJobId(selectedApproveJob.id);
        setAiJobError(null);
        aiJobService.approveJob(selectedApproveJob.id).then(data => {
            updateAiJobInList(data);
            if (selectedAiJobDetails && selectedAiJobDetails.id === data.id) {
                setSelectedAiJobDetails(mergeAiJob(selectedAiJobDetails, data));
            }
            if (data.status === "completed") {
                toast.current.show({severity: 'success', summary: t('ai_job.approved_deployed'), detail: t('message_detail.successful')});
            }
            if (data.status === "approval_failed") {
                setAiJobError(data.error_message || t('ai_job.approval_failed'));
            }
            setSelectedApproveJob(null);
            setApprovingAiJobId(null);
        }).catch(error => {
            if (error && error.response && error.response.status === 401) {
                setError(error);
                setError(null);
            } else if (error && error.response && error.response.status === 400) {
                setAiJobError(getAiJobApprovalErrorMessage(error) || t('ai_job.cannot_approve_current_status'));
            } else {
                setAiJobError(getAiJobErrorMessage(error));
            }
            setSelectedApproveJob(null);
            setApprovingAiJobId(null);
        });
    };

    const applyAiJobCorrection = () => {
        if (!selectedCorrectionJob || !correctionReviewNote.trim())
            return;

        setCorrectionLoading(true);
        setCorrectionError(null);
        aiJobService.applyCorrection(selectedCorrectionJob.id, correctionReviewNote.trim()).then(data => {
            updateAiJobInList(data);
            if (selectedAiJobDetails && selectedAiJobDetails.id === data.id) {
                setSelectedAiJobDetails(mergeAiJob(selectedAiJobDetails, data));
            }
            setSelectedCorrectionJob(null);
            setCorrectionReviewNote("");
            setCorrectionLoading(false);
            toast.current.show({severity: 'success', summary: t('ai_job.correction_applied'), detail: t('message_detail.successful')});
            refreshAiJobLogs(data.id);
        }).catch(error => {
            if (error && error.response && error.response.status === 401) {
                setError(error);
                setError(null);
            }
            setCorrectionError(getAiJobErrorMessage(error));
            setCorrectionLoading(false);
        });
    };

    const statusTemplate = (job) => {
        const statusMap = {
            waiting_user_review: {label: t('ai_job.waiting_for_review'), className: "p-tag p-tag-warning"},
            correction_failed: {label: t('ai_job.correction_failed'), className: "p-tag p-tag-danger"},
            merging_pull_request: {label: t('ai_job.merging_pull_request'), className: "p-tag p-tag-info"},
            deploying_prod: {label: t('ai_job.deploying_prod'), className: "p-tag p-tag-info"},
            deleting_branch: {label: t('ai_job.deleting_branch'), className: "p-tag p-tag-info"},
            completed: {label: t('ai_job.completed'), className: "p-tag p-tag-success"},
            approval_failed: {label: t('ai_job.approval_failed'), className: "p-tag p-tag-danger"},
            failed: {label: t('ai_job.failed'), className: "p-tag p-tag-danger"}
        };
        const status = statusMap[job.status] || {label: job.status, className: "p-tag p-tag-info"};
        return <span className={status.className}>{status.label}</span>;
    };

    const dateTimeTemplate = (value) => {
        return value ? toDateTimeString(value) : "-";
    };

    const aiJobActionTemplate = (job) => {
        return <div>
            <Button icon="pi pi-info"
                    className="p-button-outlined p-button-info"
                    tooltip={t('actions.detail')}
                    tooltipOptions={{position: 'bottom'}}
                    onClick={() => openAiJobDetails(job)}
                    style={{marginRight: ".5em"}}/>
            {job.pull_request_url &&
                <Button icon="pi pi-external-link"
                        className="p-button-outlined p-button-success"
                        tooltip={t('actions.open_pr')}
                        tooltipOptions={{position: 'bottom'}}
                        onClick={() => window.open(job.pull_request_url, "_blank", "noopener,noreferrer")}
                        style={{marginRight: ".5em"}}/>}
            {canApproveAiJob(job) &&
                <Button icon={approvingAiJobId === job.id ? "pi pi-spin pi-spinner" : "pi pi-check"}
                        className="p-button-outlined p-button-warning"
                        tooltip={approvingAiJobId === job.id ? t('ai_job.approving') : t('actions.approve_and_deploy')}
                        tooltipOptions={{position: 'bottom'}}
                        disabled={!!approvingAiJobId}
                        onClick={() => setSelectedApproveJob(job)}
                        style={{marginRight: ".5em"}}/>}
            {canRequestAiJobCorrection(job) &&
                <Button icon="pi pi-comment"
                        className="p-button-outlined p-button-help"
                        tooltip={t('actions.request_change')}
                        tooltipOptions={{position: 'bottom'}}
                        disabled={correctionLoading}
                        onClick={() => openAiJobCorrectionDialog(job)}
                        style={{marginRight: ".5em"}}/>}
            {job.status === "failed" &&
                <Button icon={aiJobCreateLoading ? "pi pi-spin pi-spinner" : "pi pi-replay"}
                        className="p-button-outlined p-button-danger"
                        tooltip={t('actions.retry')}
                        tooltipOptions={{position: 'bottom'}}
                        disabled={aiJobCreateLoading}
                        onClick={() => createAiJob(job.provider || "gemini", job.base_branch || "master", job.model_name || null)}
                        style={{marginRight: ".5em"}}/>}
            <Button icon="pi pi-refresh"
                    className="p-button-outlined"
                    tooltip={t('actions.refresh')}
                    tooltipOptions={{position: 'bottom'}}
                    onClick={() => refreshAiJob(job)}/>
        </div>;
    };

    const aiJobCreateFormTemplate = () => {
        if (!showAiJobCreateForm)
            return null;

        const providerOptions = (getFixSpiderOperation()?.providers || []).map(provider => {
            return {
                label: provider.is_implemented === false ? provider.name + " (" + t('ai_job.not_implemented') + ")" : provider.name,
                value: provider.name,
                disabled: provider.is_implemented === false
            };
        });
        const modelOptions = getProviderModels().map(model => {
            return {
                label: model.label || model.name,
                value: model.name,
                cost_category: model.cost_category
            };
        });
        const selectedProvider = getSelectedProvider();
        const modelDropdownDisabled = aiOperationsLoading || !selectedProvider || selectedProvider.is_implemented === false || modelOptions.length === 0;

        return <div className="p-grid p-col-12" style={{border: "1px solid #ddd", marginTop: ".75em", padding: ".75em"}}>
            {aiOperationsLoading &&
                <div className="p-col-12">
                    <span className="p-tag p-tag-info">{t('ai_job.loading_operations')}</span>
                </div>
            }
            <div className="p-col-12 p-md-4">
                <span className="p-float-label">
                    <Dropdown id="ai_provider"
                              value={aiProvider}
                              options={providerOptions}
                              optionDisabled="disabled"
                              onChange={(e) => selectProviderDefaults(e.value)}
                              style={{width: "100%"}}
                              disabled={aiOperationsLoading || providerOptions.length === 0}/>
                    <label htmlFor="ai_provider">{t('ai_job.provider')}</label>
                </span>
            </div>
            <div className="p-col-12 p-md-4">
                <span className="p-float-label">
                    <Dropdown id="ai_model"
                              value={aiModelName}
                              options={modelOptions}
                              onChange={(e) => setAiModelName(e.value)}
                              style={{width: "100%"}}
                              disabled={modelDropdownDisabled}/>
                    <label htmlFor="ai_model">{t('ai_job.model')}</label>
                </span>
            </div>
            <div className="p-col-12 p-md-4">
                <span className="p-float-label">
                    <InputText id="ai_base_branch" value={aiBaseBranch} onChange={(e) => setAiBaseBranch(e.target.value)} style={{width: "100%"}}/>
                    <label htmlFor="ai_base_branch">{t('ai_job.base_branch')}</label>
                </span>
            </div>
            <div className="p-col-12">
                <span className="p-tag p-tag-info" style={{marginRight: ".5em"}}>scraper</span>
                <span className="p-tag p-tag-info" style={{marginRight: ".5em"}}>pricescraper</span>
                <span className="p-tag p-tag-info">fix-spider</span>
            </div>
            <div className="p-col-12" style={{textAlign: "right"}}>
                <Button label={aiJobCreateLoading ? t('ai_job.creating') : t('actions.create_ai_fix_job')}
                        icon={aiJobCreateLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                        disabled={aiJobCreateLoading || aiOperationsLoading || !aiBaseBranch || !aiProvider || modelDropdownDisabled}
                        onClick={() => createAiJob()}
                        style={{marginRight: ".5em"}}/>
                <Button label={t('actions.cancel')} className="p-button-outlined" onClick={() => setShowAiJobCreateForm(false)} disabled={aiJobCreateLoading}/>
            </div>
        </div>;
    };

    const aiJobPanelTemplate = () => {
        const exceptionHash = selectedFailureDetail ? selectedFailureDetail.exception_hash : null;

        return <div className="p-grid p-col-12" style={{borderTop: "1px solid #ddd", marginTop: "1em", paddingTop: "1em"}}>
            <div className="p-col-6">
                <h5 style={{marginTop: 0, fontWeight: "bold", fontSize: "1.15rem"}}>{t('ai_job.title')}</h5>
            </div>
            <div className="p-col-6" style={{textAlign: "right"}}>
                <Button label={t('actions.refresh')} icon={aiJobsLoading ? "pi pi-spin pi-spinner" : "pi pi-refresh"} className="p-button-outlined" disabled={aiJobsLoading || !exceptionHash} onClick={() => loadAiJobs(exceptionHash)} style={{marginRight: ".5em"}}/>
                <Button label={t('actions.create_ai_fix_job')} icon="pi pi-bolt" className="p-button-warning" disabled={!exceptionHash} onClick={openAiJobCreateForm}/>
            </div>
            {aiJobError &&
                <div className="p-col-12">
                    <span className="p-tag p-tag-danger" style={{whiteSpace: "normal"}}>{aiJobError}</span>
                </div>
            }
            {aiJobCreateFormTemplate()}
            {aiJobsLoading
                ?
                <div className="p-col-12" style={{textAlign:'center'}}>
                    <div>{t('ai_job.loading_list')}</div>
                    <Loading/>
                </div>
                :
                <div className="p-col-12">
                    {aiJobs.length === 0
                        ?
                        <div>{t('ai_job.empty')}</div>
                        :
                        <DataTable value={aiJobs} dataKey="id" responsive={true} paginator={true} rows={5}>
                            <Column field="status" header={t('ai_job.status')} body={statusTemplate} style={{width: "10em"}}/>
                            <Column field="provider" header={t('ai_job.provider')} style={{width: "8em"}}/>
                            <Column field="operation" header={t('ai_job.operation')} style={{width: "9em"}}/>
                            <Column field="updated_at" header={t('ai_job.updated_at')} body={(job) => dateTimeTemplate(job.updated_at)} style={{width: "11em"}}/>
                            <Column header={t('table_headers.action')} body={aiJobActionTemplate} style={{width: "11em"}}/>
                        </DataTable>
                    }
                </div>
            }
        </div>;
    };

    const getAiJobLogActionLabel = (log) => {
        if (log.action === "review_correction_requested")
            return t('ai_job.log_review_correction_requested');
        if (log.action === "ai_provider_response" && log.payload && log.payload.request && log.payload.request.type === "initial_fix")
            return t('ai_job.log_initial_ai_response');
        if (log.action === "ai_provider_response" && log.payload && log.payload.request && log.payload.request.type === "review_correction")
            return t('ai_job.log_review_correction_ai_response');
        return log.action || "-";
    };

    const logActionTemplate = (log) => {
        return getAiJobLogActionLabel(log);
    };

    const logPayloadTemplate = (log) => {
        const payload = log.payload || {};
        const response = payload.response || {};
        const diffSummary = response.diff_summary || {};
        const testsToRun = response.tests_to_run || [];

        return <div className="p-grid" style={{padding: ".5em 1em"}}>
            {payload.review_note &&
                <div className="p-col-12">
                    <b>{t('ai_job.review_note')}</b>
                    <div style={{whiteSpace: "pre-wrap", wordBreak: "break-word"}}>{payload.review_note}</div>
                </div>
            }
            {payload.request &&
                <div className="p-col-12">
                    <b>{t('ai_job.log_request')}</b>
                    <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "12em", overflow: "auto"}}>{JSON.stringify(payload.request, null, 2)}</pre>
                </div>
            }
            {response.diagnosis &&
                <div className="p-col-12">
                    <b>{t('ai_job.diagnosis')}</b>
                    <div style={{whiteSpace: "pre-wrap", wordBreak: "break-word"}}>{response.diagnosis}</div>
                </div>
            }
            {(diffSummary.changed_files !== undefined || diffSummary.added_lines !== undefined || diffSummary.removed_lines !== undefined) &&
                <div className="p-col-12">
                    <b>{t('ai_job.log_diff_summary')}</b>
                    <div>
                        <span className="p-tag p-tag-info" style={{marginRight: ".5em"}}>{t('ai_job.changed_files')}: {diffSummary.changed_files !== undefined ? diffSummary.changed_files : "-"}</span>
                        <span className="p-tag p-tag-success" style={{marginRight: ".5em"}}>{t('ai_job.added_lines')}: {diffSummary.added_lines !== undefined ? diffSummary.added_lines : "-"}</span>
                        <span className="p-tag p-tag-warning">{t('ai_job.removed_lines')}: {diffSummary.removed_lines !== undefined ? diffSummary.removed_lines : "-"}</span>
                    </div>
                </div>
            }
            {response.tests_to_run &&
                <div className="p-col-12">
                    <b>{t('ai_job.tests_to_run')}</b>
                    {testsToRun.length > 0
                        ? <ul>{testsToRun.map((test, index) => <li key={index}>{test}</li>)}</ul>
                        : <div>-</div>}
                </div>
            }
            {response.diff &&
                <div className="p-col-12">
                    <details>
                        <summary>{t('ai_job.diff')}</summary>
                        <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "18em", overflow: "auto", border: "1px solid #ddd", padding: "1em", marginTop: ".5em"}}>{response.diff}</pre>
                    </details>
                </div>
            }
            {Object.keys(payload).length === 0 &&
                <div className="p-col-12">-</div>
            }
        </div>;
    };

    const aiJobLogsTemplate = (job) => {
        const logs = sortAiJobLogs(job.logs);

        return <div className="p-col-12" style={{borderTop: "1px solid #ddd", marginTop: "1em", paddingTop: "1em"}}>
            <div className="p-grid">
                <div className="p-col-6">
                    <h5 style={{marginTop: 0, fontWeight: "bold"}}>{t('ai_job.operation_logs')}</h5>
                </div>
                <div className="p-col-6" style={{textAlign: "right"}}>
                    <Button label={t('actions.refresh_logs')}
                            icon={aiJobLogsLoading ? "pi pi-spin pi-spinner" : "pi pi-refresh"}
                            className="p-button-outlined"
                            disabled={aiJobLogsLoading}
                            onClick={() => refreshAiJobLogs(job.id)}/>
                </div>
                {logs.length === 0
                    ?
                    <div className="p-col-12">{t('ai_job.logs_empty')}</div>
                    :
                    <div className="p-col-12">
                        <DataTable value={logs} dataKey="id" responsive={true} expandedRows={expandedAiJobLogRows} onRowToggle={(e) => setExpandedAiJobLogRows(e.data)} rowExpansionTemplate={logPayloadTemplate}>
                            <Column expander={true} style={{width: "3em"}}/>
                            <Column field="created_at" header={t('ai_job.time')} body={(log) => dateTimeTemplate(log.created_at)} style={{width: "12em"}}/>
                            <Column field="action" header={t('ai_job.action')} body={logActionTemplate}/>
                            <Column field="provider" header={t('ai_job.provider')} style={{width: "8em"}}/>
                            <Column field="status" header={t('ai_job.status')} style={{width: "12em"}}/>
                            <Column field="message" header={t('ai_job.message')} body={(log) => log.message || "-"}/>
                        </DataTable>
                    </div>
                }
            </div>
        </div>;
    };

    const aiJobDetailsDialogTemplate = () => {
        if (!selectedAiJobDetails)
            return null;

        return <Dialog header={t('ai_job.details')} visible={!!selectedAiJobDetails} style={{maxWidth: '70vw', minWidth: '45vw'}} modal={true}
                       onHide={() => setSelectedAiJobDetails(null)}>
            <div className="p-grid">
                <div className="p-col-12 p-md-6">
                    {statusTemplate(selectedAiJobDetails)}
                    <span className="p-tag p-tag-info" style={{marginLeft: ".5em"}}>{selectedAiJobDetails.provider}</span>
                    <span className="p-tag p-tag-info" style={{marginLeft: ".5em"}}>{selectedAiJobDetails.operation}</span>
                </div>
                {(selectedAiJobDetails.pull_request_url || canRequestAiJobCorrection(selectedAiJobDetails)) &&
                    <div className="p-col-12 p-md-6" style={{textAlign: "right"}}>
                        {canApproveAiJob(selectedAiJobDetails) &&
                            <Button label={approvingAiJobId === selectedAiJobDetails.id ? t('ai_job.approving') : t('actions.approve_and_deploy')}
                                    icon={approvingAiJobId === selectedAiJobDetails.id ? "pi pi-spin pi-spinner" : "pi pi-check"}
                                    className="p-button-warning"
                                    disabled={!!approvingAiJobId}
                                    onClick={() => setSelectedApproveJob(selectedAiJobDetails)}
                                    style={{marginRight: ".5em"}}/>}
                        {canRequestAiJobCorrection(selectedAiJobDetails) &&
                            <Button label={t('actions.request_change')}
                                    icon="pi pi-comment"
                                    className="p-button-help"
                                    disabled={correctionLoading}
                                    onClick={() => openAiJobCorrectionDialog(selectedAiJobDetails)}
                                    style={{marginRight: ".5em"}}/>}
                        {selectedAiJobDetails.pull_request_url &&
                            <Button label={t('actions.open_pr')} icon="pi pi-external-link" className="p-button-success" onClick={() => window.open(selectedAiJobDetails.pull_request_url, "_blank", "noopener,noreferrer")}/>}
                    </div>
                }
                <div className="p-col-12">
                    <b>{t('ai_job.branch_name')}</b>
                    <div style={{wordBreak: "break-word"}}>{selectedAiJobDetails.branch_name || "-"}</div>
                </div>
                <div className="p-col-12 p-md-4">
                    <b>{t('ai_job.created_at')}</b>
                    <div>{dateTimeTemplate(selectedAiJobDetails.created_at)}</div>
                </div>
                <div className="p-col-12 p-md-4">
                    <b>{t('ai_job.updated_at')}</b>
                    <div>{dateTimeTemplate(selectedAiJobDetails.updated_at)}</div>
                </div>
                <div className="p-col-12 p-md-4">
                    <b>{t('ai_job.verification_status')}</b>
                    <div>{selectedAiJobDetails.verification_status || "-"}</div>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.change_summary')}</b>
                    <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "18em", overflow: "auto"}}>{selectedAiJobDetails.diff || "-"}</pre>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.diagnosis')}</b>
                    <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "18em", overflow: "auto"}}>{selectedAiJobDetails.diagnosis || "-"}</pre>
                </div>
                {selectedAiJobDetails.error_message &&
                    <div className="p-col-12">
                        <b>{t('ai_job.error_message')}</b>
                        <div>
                            <span className="p-tag p-tag-danger" style={{whiteSpace: "normal"}}>{selectedAiJobDetails.error_message}</span>
                        </div>
                    </div>
                }
                {aiJobLogsTemplate(selectedAiJobDetails)}
            </div>
        </Dialog>;
    };

    const approveAiJobConfirmationFooter = () => {
        return <div>
            <Button label={t('actions.cancel')}
                    className="p-button-outlined"
                    disabled={!!approvingAiJobId}
                    onClick={() => setSelectedApproveJob(null)}
                    style={{marginRight: ".5em"}}/>
            <Button label={approvingAiJobId ? t('ai_job.approving') : t('actions.approve_and_deploy')}
                    icon={approvingAiJobId ? "pi pi-spin pi-spinner" : "pi pi-check"}
                    className="p-button-warning"
                    disabled={!!approvingAiJobId}
                    onClick={approveAiJob}/>
        </div>;
    };

    const aiJobCorrectionDialogFooter = () => {
        return <div>
            <Button label={t('actions.cancel')}
                    className="p-button-outlined"
                    disabled={correctionLoading}
                    onClick={() => setSelectedCorrectionJob(null)}
                    style={{marginRight: ".5em"}}/>
            <Button label={correctionLoading ? t('ai_job.correction_preparing') : t('actions.request_change')}
                    icon={correctionLoading ? "pi pi-spin pi-spinner" : "pi pi-comment"}
                    className="p-button-help"
                    disabled={correctionLoading || !correctionReviewNote.trim()}
                    onClick={applyAiJobCorrection}/>
        </div>;
    };

    const aiJobCorrectionDialogTemplate = () => {
        if (!selectedCorrectionJob)
            return null;

        return <Dialog header={t('ai_job.request_correction_title')} visible={!!selectedCorrectionJob} style={{maxWidth: '70vw', minWidth: '50vw'}} modal={true}
                       footer={aiJobCorrectionDialogFooter()}
                       onHide={() => !correctionLoading && setSelectedCorrectionJob(null)}>
            <div className="p-grid">
                {correctionError &&
                    <div className="p-col-12">
                        <span className="p-tag p-tag-danger" style={{whiteSpace: "normal"}}>{correctionError}</span>
                    </div>
                }
                {correctionLoading &&
                    <div className="p-col-12">
                        <span className="p-tag p-tag-info">{t('ai_job.correction_preparing')}</span>
                    </div>
                }
                <div className="p-col-12">
                    <b>{t('ai_job.pull_request_url')}</b>
                    <div style={{wordBreak: "break-word"}}>
                        {selectedCorrectionJob.pull_request_url
                            ? <a href={selectedCorrectionJob.pull_request_url} target="_blank" rel="noopener noreferrer">{selectedCorrectionJob.pull_request_url}</a>
                            : "-"}
                    </div>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.branch_name')}</b>
                    <div style={{wordBreak: "break-word"}}>{selectedCorrectionJob.branch_name || "-"}</div>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.change_summary')}</b>
                    <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "14em", overflow: "auto"}}>{selectedCorrectionJob.diff || "-"}</pre>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.diagnosis')}</b>
                    <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "14em", overflow: "auto"}}>{selectedCorrectionJob.diagnosis || "-"}</pre>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.review_note')}</b>
                    <InputTextarea value={correctionReviewNote}
                                   onChange={(e) => setCorrectionReviewNote(e.target.value)}
                                   rows={6}
                                   style={{width: "100%", marginTop: ".5em"}}
                                   disabled={correctionLoading}/>
                </div>
            </div>
        </Dialog>;
    };

    const manualPromptDialogFooter = () => {
        return <div>
            <Button label={t('actions.copy_prompt')}
                    icon="pi pi-copy"
                    className="p-button-outlined p-button-info"
                    disabled={!manualPromptData || !manualPromptData.prompt}
                    onClick={copyManualPrompt}
                    style={{marginRight: ".5em"}}/>
            <Button label={t('actions.close')} icon="pi pi-times" className="p-button-outlined p-button-danger" onClick={() => setManualPromptData(null)}/>
        </div>;
    };

    const manualPromptDialogTemplate = () => {
        if (!manualPromptData)
            return null;

        return <Dialog header={t('ai_job.manual_fix_prompt')} visible={!!manualPromptData} style={{maxWidth: '75vw', minWidth: '55vw'}} modal={true}
                       footer={manualPromptDialogFooter()}
                       onHide={() => setManualPromptData(null)}>
            <div className="p-grid">
                <div className="p-col-12 p-md-6">
                    <b>{t('ai_job.exception_hash')}</b>
                    <div style={{wordBreak: "break-word"}}>{manualPromptData.exception_hash || "-"}</div>
                </div>
                <div className="p-col-12 p-md-6">
                    <b>{t('ai_job.response_filename')}</b>
                    <div style={{wordBreak: "break-word"}}>{manualPromptData.response_filename || "-"}</div>
                </div>
                <div className="p-col-12 p-md-6">
                    <b>{t('ai_job.response_text_size')}</b>
                    <div>{manualPromptData.response_text_size !== null && manualPromptData.response_text_size !== undefined ? manualPromptData.response_text_size : "-"}</div>
                </div>
                <div className="p-col-12 p-md-6">
                    <b>{t('ai_job.response_download_url')}</b>
                    <div style={{wordBreak: "break-word"}}>{manualPromptData.response_download_url || "-"}</div>
                </div>
                <div className="p-col-12">
                    <b>{t('ai_job.prompt_text')}</b>
                    <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "32em", overflow: "auto", fontFamily: "monospace", border: "1px solid #ddd", padding: "1em", marginTop: ".5em"}}>{manualPromptData.prompt || "-"}</pre>
                </div>
            </div>
        </Dialog>;
    };

    return <React.Fragment>

        <Dialog header="Exception Detail" visible={showFailureDetailModal} style={{maxWidth: '80vw', minWidth: '50vw'}} modal={true}
                onHide={() => {setShowFailureDetailModal(false); setSelectedFailureDetail(null); setSelectedFailureDetails([]); resetAiJobPanel();}}>
            {selectedFailureDetail &&
                <React.Fragment>
                    {selectedFailureDetail.redirect_url &&
                        <div className="p-grid p-col-12">
                            <div className="p-col-3"><b>{t('scraping_request.redirect_url')}</b></div>
                            <div className="p-col-9">{failedRedirectUrlTemplate(selectedFailureDetail)}</div>
                        </div>
                    }
                    <div className="p-grid p-col-12">
                        <div className="p-col-3"><b>{t('scraping_request.product_id')}</b></div>
                        <div className="p-col-9">{failedProductsTemplate()}</div>
                    </div>
                    <div className="p-grid p-col-12">
                        <div className="p-col-3"><b>Exception Detail</b></div>
                        <div className="p-col-9">
                            {exceptionTemplate(selectedFailureDetail)}
                        </div>
                    </div>
                    {selectedFailureDetail.exception_hash &&
                        <div className="p-grid p-col-12">
                            <div className="p-col-fixed">
                                {failureResponseTemplate(selectedFailureDetail)}
                                <Button label={t('actions.download_response')}
                                        icon={responseDownloadLoading ? "pi pi-spin pi-spinner" : "pi pi-download"}
                                        className="p-button-outlined p-button-info"
                                        disabled={responseDownloadLoading}
                                        onClick={() => downloadFailureResponse(selectedFailureDetail.exception_hash)}
                                        style={{marginLeft: ".5em"}}/>
                                <Button label={t('actions.build_manual_prompt')}
                                        icon={manualPromptLoading ? "pi pi-spin pi-spinner" : "pi pi-bolt"}
                                        className="p-button-outlined p-button-warning"
                                        disabled={manualPromptLoading}
                                        onClick={buildManualPrompt}
                                        style={{marginLeft: ".5em"}}/>
                                {probeUrlOptions().length > 0 &&
                                    <Button label={t('request_probe.create_new')}
                                            icon="pi pi-bolt"
                                            className="p-button-outlined p-button-help"
                                            onClick={openProbeDialog}
                                            style={{marginLeft: ".5em"}}/>}
                            </div>
                        </div>
                    }
                    {aiJobPanelTemplate()}
                </React.Fragment>
            }
        </Dialog>
        <Dialog header={t('request_probe.create_new')} visible={showProbeDialog} style={{maxWidth: '46em', width: '90vw'}} modal={true}
                onHide={() => !probeLoading && setShowProbeDialog(false)}
                footer={<div>
                    <Button label={t('actions.cancel')} icon="pi pi-times" className="p-button-text"
                            disabled={probeLoading} onClick={() => setShowProbeDialog(false)}/>
                    <Button label={probeLoading ? t('request_probe.creating') : t('request_probe.create_new')} icon="pi pi-send"
                            loading={probeLoading} disabled={!probeUrl || probeLoading} onClick={createProductUrlProbe}/>
                </div>}>
            <div className="p-fluid">
                <div className="p-field">
                    <label htmlFor="probe_url_select">{t('request_probe.url')}</label>
                    <Dropdown id="probe_url_select" value={probeUrl} options={probeUrlOptions()}
                              onChange={(e) => setProbeUrl(e.value)}/>
                </div>
            </div>
        </Dialog>
        {aiJobDetailsDialogTemplate()}
        {aiJobCorrectionDialogTemplate()}
        {manualPromptDialogTemplate()}
        <Dialog header={t('ai_job.approve_confirm_title')} visible={!!selectedApproveJob} style={{maxWidth: '35vw', minWidth: '28vw'}} modal={true}
                footer={approveAiJobConfirmationFooter()}
                onHide={() => !approvingAiJobId && setSelectedApproveJob(null)}>
            <div>{t('ai_job.approve_confirm_body')}</div>
        </Dialog>

        <div className="p-grid">
            <div className="p-col-6">
                <Button tooltip={t('actions.previous')} tooltipOptions={{position: 'bottom'}} icon="pi pi-angle-left"
                        className="p-button-outlined" onClick={previousDate} style={{marginRight:'0.5em'}} />
                <Calendar id="date" name="date" readOnlyInput={true} value={new Date(date)} onChange={selectDate}
                          showIcon={true} dateFormat="yy-mm-dd" showButtonBar={true} style={{marginRight:'0.5em'}} />
                <Button tooltip={t('actions.next')} tooltipOptions={{position: 'bottom'}} icon="pi pi-angle-right"
                        className="p-button-outlined" onClick={nextDate} style={{marginRight:'0.5em'}}/>
                {selectedListType === "failed_requests_overview" &&
                    <MultiSelect id="userOption" name="userOption" value={filteredUserEmails} options={userOptions}
                                 filter={true}
                                 onChange={filterItems}
                                 placeholder={t('user.email')}
                                 style={{marginRight: '0.5em', width: "30%"}}/>
                }
            </div>

            <div className="p-col-6">
                <SelectButton value={selectedListType} optionLabel="label" options={listTypes}
                              onChange={(e) => {setSelectedListType(e.value)}}
                              style={{ marginRight:'.5em', float: 'right'}}/>
            </div>

        </div>

        {loading
            ?
            <div className="p-grid p-col-12" style={{textAlign:'center'}}>
                <Loading/>
            </div>
            :
            <React.Fragment>
                {selectedListType === "failed_requests_based_hostname" &&
                    <div className="p-grid p-fluid dashboard card">
                        <div className="p-col-3">
                            <div className="card summary">
                                <button className="p-link" onClick={() => {
                                }}>
                                    <span className="title">{t('scraping_request.total_real_failure')}</span>
                                </button>
                                <span className="detail">{t('scraping_request.total_real_failure_detail')}</span>
                                <span className="count red">{totalRealFailure}</span>
                            </div>
                        </div>
                        <div className="p-col-3">
                            <div className="card summary">
                                <button className="p-link" onClick={() => {
                                }}>
                                    <span className="title">{t('scraping_request.total_http_5xx')}</span>
                                </button>
                                <span className="detail">{t('scraping_request.total_http_5xx_detail')}</span>
                                <span className="count yellow">{totalHttp5xx}</span>
                            </div>
                        </div>
                        <div className="p-col-3">
                            <div className="card summary">
                                <button className="p-link" onClick={() => {
                                }}>
                                    <span className="title">{t('scraping_request.total_http_4xx')}</span>
                                </button>
                                <span className="detail">{t('scraping_request.total_http_4xx_detail')}</span>
                                <span className="count blue">{totalHttp4xx}</span>
                            </div>
                        </div>
                        <div className="p-col-3">
                            <div className="card summary">
                                <button className="p-link" onClick={() => {
                                }}>
                                    <span className="title">{t('scraping_request.total_connection_failure')}</span>
                                </button>
                                <span className="detail">{t('scraping_request.total_connection_failure_detail')}</span>
                                <span className="count green">{totalConnectionFailure}</span>
                            </div>
                        </div>
                    </div>
                }

                <div className="p-grid p-fluid">
                    {selectedListType === "failed_requests_overview" &&
                        <div className="p-grid p-col-12" style={{textAlign:'center'}}>
                            <DataTable value={filteredFailedRequestsDigest} dataKey="id">
                                <Column header={t('scraping_request.failed_requests_overview')} body={digestTemplate}/>
                            </DataTable>
                        </div>
                    }

                    {selectedListType === "failed_requests_based_hostname" &&
                        <DataTable value={filteredFailedRequestsBasedHostname} emptyMessage={t('actions.empty_message')} paginator={true} rows={100}>
                            <Column body={IndexTemplate} style={{width:'3em'}} />
                            <Column field="hostname" style={{width: '230px'}} header={t('scraping_request.hostname')} sortable/>
                            <Column field="exception" header={t('scraping_request.exception')} sortable/>
                            <Column field="total_failure_count" style={{width: '100px'}} header={t('scraping_request.error_count')} sortable/>
                            <Column field="total_real_failure_count" style={{width: '100px'}} header={t('scraping_request.total_real_failure')} sortable/>
                            <Column field="total_http_5xx" style={{width: '100px'}} header={t('scraping_request.total_http_5xx')} sortable/>
                            <Column field="total_http_4xx" style={{width: '100px'}} header={t('scraping_request.total_http_4xx')} sortable/>
                            <Column field="total_connection_failure" style={{width: '100px'}} header={t('scraping_request.total_connection_failure')} sortable/>
                            <Column header={t('table_headers.action')} body={actionTemplate} style={{textAlign:'center', width:'12em'}}/>
                        </DataTable>
                    }

                    {selectedListType === "jobs_runtime" &&
                        <div className="p-grid p-col-12" style={{textAlign: 'center'}}>
                            <DataTable value={filteredJobsRunTime} dataKey="id">
                                <Column header={t('scraping_request.jobs_runtime')} body={jobsRunTimeTemplate}
                                       />
                            </DataTable>
                        </div>
                    }

                </div>

            </React.Fragment>
        }

    </React.Fragment>;
};
export default OverviewRequest;
